
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface SubmitButtonProps {
  isEditing?: boolean;
  isSubmitting?: boolean;
}

export const SubmitButton = ({ isEditing, isSubmitting }: SubmitButtonProps) => {
  return (
    <Button
      type="submit"
      className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
      disabled={isSubmitting}
    >
      {isSubmitting ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          {isEditing ? "Actualizando..." : "Creando..."}
        </>
      ) : (
        <>{isEditing ? "Actualizar Clase" : "Crear Clase"}</>
      )}
    </Button>
  );
};
